<template>
	<div class="main-container">
        <v-container class="pa-0 r-p-x-0">
            <v-row no-gutters justify="center" align="center" class="py-120 bg-black">
                <FeeConflict></FeeConflict>
            </v-row>
            <v-row no-gutters justify="center" align="center" class="py-120 bg-black" id="pe">
                <ProfitExpectancy></ProfitExpectancy>
            </v-row>
            <Footer class="bg-black"></Footer>
        </v-container>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import FeeConflict from './v3/components/FeeConflict.vue';
import Footer from './v3/components/Footer.vue';
import ProfitExpectancy from './v3/components/ProfitExpectancy.vue';
export default {
    data(){
        return {

        }
    },
    components: { FeeConflict, Footer, ProfitExpectancy},
    created(){

    },
    mounted(){

    },
    computed: {
        ...mapGetters(["darkTheme",'responsive'])
    },
    watch:{

    },
    methods: {

    }
}
</script>
<style scoped>

</style>